import type { SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/service-center': {
    title: 'Service Center',
    description: 'Live queues, waiting callers and agent availability.'
  },
  '/service-center/reports': {
    title: 'Service Center reports',
    description:
      'Call outcomes, queue and agent measures, and callback history.'
  },
  '/service-center/settings': {
    title: 'Service Center settings',
    description: 'Queue staffing, phone routing and dispositions.'
  },
  '/service-center/ivr': {
    title: 'IVR and prompts',
    description:
      'Save and preview drafts, then publish a version for new calls.'
  }
}
